import { ComputedSectionSchema } from 'features/libra/sections/computedSection/computedSectionTypes'
import { FlowchartSectionSchema } from 'features/libra/sections/flowchartSection/flowchartTypes'
import { FormSectionSchema } from 'features/libra/sections/formSection/formSectionTypes'
import { z } from 'zod'

export enum SectionType {
  FORM = 'form',
  FLOWCHART = 'flowchart',
  COMPUTED = 'computed',
}

export const SectionSchema = z.union([
  FlowchartSectionSchema,
  FormSectionSchema,
  ComputedSectionSchema,
])

export type FormSection = z.infer<typeof FormSectionSchema>
export type FlowchartSection = z.infer<typeof FlowchartSectionSchema>
export type ComputedSection = z.infer<typeof ComputedSectionSchema>
export type Section = FormSection | FlowchartSection | ComputedSection
